import { getConfigByEnv } from "config";

// Must set window.AIVA_MICROFRONTEND_URL synchronously BEFORE the async import,
// so Module Federation's external-remotes-plugin can resolve the remote URL.
const cfg = getConfigByEnv();
if (cfg.aivaConfig.aivaMicrofrontendUrl) {
  (window as any).AIVA_MICROFRONTEND_URL = cfg.aivaConfig.aivaMicrofrontendUrl;
}

import("./bootstrap");
